import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    itemId: String
  }

  updateTurboFrame(event) {
    const turboFrame = document.querySelector('#add-to-playlist-dialog turbo-frame')

    if (!this.hasItemIdValue) {
      console.error("Item ID value is not set on this controller")
      return
    }

    if (turboFrame && this.itemIdValue) {
      const urlTemplate = turboFrame.dataset.urlTemplate
      turboFrame.src = urlTemplate.replace('__ITEM_ID__', this.itemIdValue)
    } else {
      console.error("TurboFrame or itemId not found!")
    }
  }
}
